import {
  SET_FAVORITES_YACHTS, SET_IS_MORE_LICENSES, SET_IS_MORE_TEAM, SET_IS_MORE_YACHTS,
  SET_IYT_LICENSES,
  SET_LICENSES,
  SET_RESUME,
  SET_RESUME_CHARTERS,
  SET_RESUME_LICENSES,
  SET_SHARED_RESUME, SET_TEAM
} from "./profile-types";


const initialState = {
  licenses: null,
  resume: undefined,
  resumeLicenses: null,
  resumeCharters: null,
  iytLicenses: null,
  sharedResume: null,
  favoriteYachts: null,
  team: [],

  isMoreLicenses: true,
  isMoreYachts: true,
  isMoreTeam: true
}

export const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LICENSES: return {...state, licenses: action.licenses}
    case SET_RESUME: return {...state, resume: action.resume}
    case SET_RESUME_LICENSES: return {...state, resumeLicenses: action.resumeLicenses}
    case SET_RESUME_CHARTERS: return {...state, resumeCharters: action.resumeCharters}
    case SET_IYT_LICENSES: return {...state, iytLicenses: action.iytLicenses}
    case SET_SHARED_RESUME: return {...state, sharedResume: action.sharedResume}
    case SET_FAVORITES_YACHTS: return {...state, favoriteYachts: action.favoriteYachts}
    case SET_TEAM: return {...state, team: action.team}

    case SET_IS_MORE_LICENSES: return {...state, isMoreLicenses: action.isMoreLicenses}
    case SET_IS_MORE_YACHTS: return {...state, isMoreYachts: action.isMoreYachts}
    case SET_IS_MORE_TEAM: return {...state, isMoreTeam: action.isMoreTeam}
    default: return state
  }
}
